// removed by extract-text-webpack-plugin
module.exports = {"error-boundary":"index__error-boundary___3nquK","errorBoundary":"index__error-boundary___3nquK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/ErrorBoundary/index.css
// module id = 1019
// module chunks = 37